"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Table } from "@opensea/ui-kit";
import { useFormContext, useWatch } from "react-hook-form";
import { ListingFlowItemsTableFragment } from "./ListingFlowItemsTable.fragment";
import { ListingFlowItemsTableHeader } from "./ListingFlowItemsTableHeader";
import { ListingFlowItemsTableRow, ListingFlowItemsTableRowSkeleton } from "./ListingFlowItemsTableRow";
export const ListingFlowItemsTable = t0 => {
  const $ = _c(16);
  const {
    items: itemKeys,
    isReview
  } = t0;
  const items = itemKeys.map(_temp);
  const {
    control
  } = useFormContext();
  let t1;
  if ($[0] !== control) {
    t1 = {
      control,
      name: "adjustForFees"
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const adjustForFees = useWatch(t1);
  let t2;
  if ($[2] !== control) {
    t2 = {
      control,
      name: "listings"
    };
    $[2] = control;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const formItems = useWatch(t2);
  const tableItems = formItems.flatMap(formItem => {
    const matchedItem = items.find(item => item.id === formItem.id);
    return matchedItem ? [matchedItem] : [];
  });
  let t3;
  if ($[4] !== adjustForFees || $[5] !== isReview || $[6] !== tableItems.length) {
    t3 = <ListingFlowItemsTableHeader adjustForFees={adjustForFees} isReview={isReview} numItems={tableItems.length} />;
    $[4] = adjustForFees;
    $[5] = isReview;
    $[6] = tableItems.length;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isReview) {
    t4 = {
      isReview
    };
    $[8] = isReview;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4 || $[11] !== tableItems) {
    t5 = <Table className="shrink-0" context={t4} itemKey={_temp2} items={tableItems} renderRow={ListingFlowItemsTableRow} size="md" />;
    $[10] = t4;
    $[11] = tableItems;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t5) {
    t6 = <>{t3}{t5}</>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export const ListingFlowItemsTableSkeleton = t0 => {
  const $ = _c(12);
  const {
    count
  } = t0;
  let t1;
  if ($[0] !== count) {
    t1 = <ListingFlowItemsTableHeader isReview={false} numItems={count} skeleton={true} />;
    $[0] = count;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== count) {
    t2 = {
      count
    };
    $[2] = count;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== count) {
    t3 = new Array(count).fill(0);
    $[4] = count;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <Table className="shrink-0" context={t2} itemKey={_temp3} items={t3} renderRow={ListingFlowItemsTableRowSkeleton} size="md" />;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <>{t1}{t4}</>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
function _temp(i) {
  return readFragment(ListingFlowItemsTableFragment, i);
}
function _temp2(item_0) {
  return item_0?.id;
}
function _temp3(_, index) {
  return index;
}